import { useEffect, useState } from "react";
import { Button, Divider, Flex, Popconfirm, Select, Typography } from "antd";
import pallete from "../../../utils/pallete";

const STATUS_OPTIONS = [
  { label: "Active", value: true },
  { label: "Non Active", value: false },
];

export default function ActivationSection({
  isActive,
  isAllowedAction,
  isLoading,
  onChange,
}) {
  const [selected, setSelected] = useState(isActive);

  useEffect(() => {
    setSelected(isActive);
  }, [isActive]);

  const isChanged = selected !== isActive;

  const saveButton = (
    <Button
      type="primary"
      loading={isLoading}
      disabled={!isChanged}
      onClick={selected ? () => onChange(true) : undefined}
      style={{ minWidth: 88, fontWeight: 600 }}
    >
      Simpan
    </Button>
  );

  return (
    <>
      <Typography.Text style={{ display: "block", marginBottom: 8 }}>
        Status Aktivasi Lembaga
      </Typography.Text>
      <Select
        style={{ width: "100%" }}
        value={selected}
        options={STATUS_OPTIONS}
        onChange={setSelected}
        disabled={!isAllowedAction || isLoading}
      />

      <div
        style={{
          marginTop: 24,
          padding: "16px 18px",
          borderRadius: 8,
          backgroundColor: pallete.primary[50],
        }}
      >
        <Typography.Text style={{ display: "block" }}>
          <Typography.Text strong>Catatan</Typography.Text>:
        </Typography.Text>
        <Typography.Text>
          Status <Typography.Text strong>Non Active</Typography.Text> akan
          menutup akses lembaga ke seluruh fitur E-Vokasi dan menyembunyikan
          datanya dari sistem.
        </Typography.Text>
      </div>

      {isAllowedAction && (
        <>
          <Divider style={{ margin: "24px 0 16px" }} />
          <Flex justify="flex-end" gap={12}>
            {isChanged && !selected ? (
              <Popconfirm
                title="Nonaktifkan Lembaga"
                description="Lembaga tidak akan dapat mengakses E-Vokasi dan tidak akan tampil di Website Vokasi."
                okText="Ya, Nonaktifkan"
                cancelText="Batal"
                okButtonProps={{ danger: true, loading: isLoading }}
                onConfirm={() => onChange(false)}
              >
                {saveButton}
              </Popconfirm>
            ) : (
              saveButton
            )}
            <Button
              onClick={() => setSelected(isActive)}
              disabled={!isChanged || isLoading}
              style={{ minWidth: 88, fontWeight: 600 }}
            >
              Batal
            </Button>
          </Flex>
        </>
      )}
    </>
  );
}
